var _effectorFileName = "/builds/gmini/front-normalized-tree/src/getRelations.ts";
export function getRelations(index) {
  var relations = {}; // Здесь можно было бы использовать Object.values(index).reduce(...),
  // но в данном месте принципиально важно быстродействие, а создание
  // массива всех элементов дерева обойдётся дороже.

  for (var key in index) {
    // Эта проверка исключает возможные перечисляемые свойства объекта,
    // которые унаследованы от его прототипов (for in их перечисляет).
    if (!Object.prototype.hasOwnProperty.call(index, key)) {
      continue;
    }

    var treeItem = index[key];

    if (treeItem.parentKey == null) {
      continue;
    }

    if (!relations[treeItem.parentKey]) {
      relations[treeItem.parentKey] = [];
    }

    var childrenKeys = relations[treeItem.parentKey];
    childrenKeys.push(treeItem.key);
  }

  return relations;
}